/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateSkillRequestBody = {
  /**
   * The user-facing skill name.
   */
  displayName: string;
  /**
   * The version the caller believes is current. When set, the write is rejected as a conflict if the skill has moved on.
   */
  expectedLatestVersionId?: string | undefined;
  /**
   * The skill ID.
   */
  id: string;
  /**
   * The canonical skill name.
   */
  name: string;
  /**
   * The optional skill summary.
   */
  summary?: string | undefined;
  /**
   * Registry tags for categorizing the skill. At most 40 tags.
   */
  tags: Array<string>;
};

/** @internal */
export type UpdateSkillRequestBody$Outbound = {
  display_name: string;
  expected_latest_version_id?: string | undefined;
  id: string;
  name: string;
  summary?: string | undefined;
  tags: Array<string>;
};

/** @internal */
export const UpdateSkillRequestBody$outboundSchema: z.ZodMiniType<
  UpdateSkillRequestBody$Outbound,
  UpdateSkillRequestBody
> = z.pipe(
  z.object({
    displayName: z.string(),
    expectedLatestVersionId: z.optional(z.string()),
    id: z.string(),
    name: z.string(),
    summary: z.optional(z.string()),
    tags: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      displayName: "display_name",
      expectedLatestVersionId: "expected_latest_version_id",
    });
  }),
);

export function updateSkillRequestBodyToJSON(
  updateSkillRequestBody: UpdateSkillRequestBody,
): string {
  return JSON.stringify(
    UpdateSkillRequestBody$outboundSchema.parse(updateSkillRequestBody),
  );
}
